import { initializeApp } from "firebase/app"

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyBpJlb0K6aSqgrhcslv6M4yNU-RBLJSNxU",
  authDomain: "vazh-kniga.firebaseapp.com",
  projectId: "vazh-kniga",
  storageBucket: "vazh-kniga.appspot.com",
  messagingSenderId: "130143398181",
  appId: "1:130143398181:web:c1fc9bd8ea987a875a52cc",
};
// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

